//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OrderLand from "./components/OrderLand";
import OrderCompletion from "./components/OrderCompletion";
import OrderSettlement from "./components/OrderSettlement";
import OriginalFile from "@/components/OriginalFile";
export default {
  name: "OrderDetail",
  components: {
    OrderLand,
    OrderCompletion,
    OrderSettlement,
    OriginalFile,
  },
  data() {
    return {
      id: "",
      detail: {},
      info: [],
      activeName: "first",
      isRequest: false,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getOrderDetail();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getOrderDetail() {
      this.$http.order.getOrderDetail({ id: this.id }).then((res) => {
        this.isRequest = true;
        this.detail = res.data;
        this.info = [res.data];
      });
    },
  },
};
